import { jsx as e, jsxs as v, Fragment as x } from "react/jsx-runtime";
import { I as D } from "../chunks/index.ed48ee81.js";
import { Modal as G } from "./Modal.js";
import { m as J } from "../chunks/make-refs.cb0b9b76.js";
import { forwardRef as K, useState as N, useEffect as L, isValidElement as P } from "react";
import { c as Q, v as U, s } from "../chunks/common.2f376a27.js";
const ee = K(
  ({
    className: g,
    heroAspectRatio: C,
    heroImgAlt: $,
    heroImgHeight: M,
    heroImgRetinaSrc: f,
    heroImgSrc: l,
    heroImgWidth: R,
    heroSlot: c,
    heroVideoIframeA11yLabel: A,
    heroVideoIframeA11yTitle: w,
    heroVideoIframeAllowSettings: B,
    heroVideoPlayBtnA11yLabel: I,
    heroVideoPlayBtnA11yTitle: k,
    heroVideoSrc: a,
    ...o
  }, F) => {
    const { modalRef: j, $videoRef: t, $videoIframeRef: i, $playBtn: d } = J(
      F,
      ["modalRef", "$videoRef", "$videoIframeRef", "$playBtn"]
    ), p = l || c, [z, b] = N(!1), [m, y] = N(null), E = !!p && !o.heading && !o.description, H = () => {
      var n, r;
      (t.current || i.current) && ((n = t.current) != null && n.paused && (t.current.play(), t.current.removeAttribute("tabindex"), t.current.focus()), a && i.current && m === null && (y(a), i.current.removeAttribute("tabindex")), (r = d.current) == null || r.setAttribute("tabindex", "-1"), b((u) => !u));
    }, O = a && /\.(mp4|webm|ogg)$/i.test(a), T = (n) => n.split(".").pop(), W = () => c && P(c) ? c : /* @__PURE__ */ e(x, { children: a && /* @__PURE__ */ v(x, { children: [
      /* @__PURE__ */ e(
        "button",
        {
          "aria-label": I,
          className: s.playButton,
          onClick: H,
          ref: d,
          title: k,
          type: "button",
          children: /* @__PURE__ */ e("span", { className: s.iconWrapper, children: /* @__PURE__ */ e(D, { icon: "24/symbol/play-solid" }) })
        }
      ),
      O ? (
        // biome-ignore lint/a11y/useMediaCaption: ok
        /* @__PURE__ */ e(
          "video",
          {
            className: s.video,
            controls: !0,
            poster: l,
            ref: t,
            tabIndex: -1,
            children: /* @__PURE__ */ e(
              "source",
              {
                src: a,
                type: `video/${T(a)}`
              }
            )
          }
        )
      ) : /* @__PURE__ */ e(
        "iframe",
        {
          ref: i,
          className: s.video,
          ...m !== null && { src: m },
          allow: B,
          title: w || A,
          allowFullScreen: !0,
          loading: "lazy",
          tabIndex: -1
        }
      )
    ] }) });
    L(() => () => {
      var n, r, u;
      (n = t.current) == null || n.pause(), (r = t.current) == null || r.setAttribute("tabindex", "-1"), i.current && (y(null), i.current.setAttribute("tabindex", "-1")), (u = d.current) == null || u.removeAttribute("tabindex"), b(!1);
    }, [o.isOpen]);
    const h = Q({ className: g, isVisualOnly: E }), q = U({ isPlaying: z });
    return /* @__PURE__ */ e(
      G,
      {
        className: h,
        bodyClassName: s.body,
        contentClassName: s.content,
        dismissClassName: s.dismiss,
        ref: j,
        isMediaModal: !0,
        ...o,
        children: p && /* @__PURE__ */ v(
          "figure",
          {
            className: q,
            style: { "--aspect-ratio": C },
            children: [
              l && /* @__PURE__ */ e(
                "img",
                {
                  className: s.image,
                  src: l,
                  ...f && { srcSet: `${f} 2x` },
                  alt: $,
                  height: M,
                  width: R,
                  loading: "lazy",
                  decoding: "async"
                }
              ),
              W()
            ]
          }
        )
      }
    );
  }
);
export {
  ee as MediaModal
};
//# sourceMappingURL=MediaModal.js.map
